// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import myBackgroundVideo from '../Assets/landingvideo.mp4'; // 1. IMPORT YOUR VIDEO HERE
// import studioLogo from '../Assets/logo-removebg-preview.png';

// const Landingscreen = () => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);

//     const menuItems = [
//         { name: 'Home', path: '/' },
//         { name: 'Projects', path: '/projects' },
//         { name: 'About Us', path: '/about' },
//         { name: 'Contact', path: '/ContactUs' }
//     ];

//     const animationStyles = `
//     @keyframes fadeInUp {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-fade-in { animation: fadeInUp 1.2s ease-out forwards; }
//   `;

//     return (
//         <div style={{
//             position: 'relative',
//             height: '100vh',
//             width: '100vw',
//             overflow: 'hidden',
//             fontFamily: 'system-ui, -apple-system, sans-serif'
//         }}>
//             <style>{animationStyles}</style>

//             {/* ==================== FIXED HEADER ==================== */}
//             <header style={{
//                 position: 'fixed',
//                 top: '20px',                  // Floats the header away from the top edge
//                 left: '50%',
//                 transform: 'translateX(-50%)', // Centers the floating container perfectly
//                 width: '90%',                 // Constrains width to create an elegant margin deck
//                 maxWidth: '1200px',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 padding: '12px 40px',         // Slimmer padding height for an editorial feel
//                 boxSizing: 'border-box',
//                 zIndex: 10,

//                 // Asymmetric Glassmorphism & Pastel Fusion
//                 background: 'rgba(248, 246, 242, 0.75)',
//                 backdropFilter: 'blur(12px) saturate(110%)',
//                 WebkitBackdropFilter: 'blur(12px) saturate(110%)',

//                 // Premium Fine Borders
//                 borderRadius: '50px',         // Capsule pill format
//                 border: '1px solid rgba(44, 48, 46, 0.08)',
//                 boxShadow: '0 10px 30px rgba(44, 48, 46, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.6)'
//             }}>

//                 {/* ==================== LEFT LOGO AREA WITH MONOGRAM HOVER ==================== */}
//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     height: '42px',           // Refined, compact vertical silhouette
//                     transition: 'transform 0.3s ease'
//                 }}
//                     onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.03)'}
//                     onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                 >
//                     <img
//                         src={studioLogo}
//                         alt="ST Interior Studio Logo"
//                         style={{
//                             height: '100%',
//                             width: 'auto',
//                             objectFit: 'contain'
//                         }}
//                     />
//                 </div>

//                 {/* ==================== RIGHT NAVIGATION & INTERACTION DECK ==================== */}
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>

//                     {/* Minimalist Tab Menu Layout */}
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             return (
//                                 <Link
//                                     key={index}
//                                     to={item.path}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         color: '#2C302E', // Deep Charcoal Base Text
//                                         textDecoration: 'none',
//                                         fontSize: '0.9rem',
//                                         fontWeight: isHovered ? '600' : '500',
//                                         letterSpacing: '0.8px',
//                                         textTransform: 'uppercase', // Architectural blueprint style
//                                         padding: '8px 18px',
//                                         borderRadius: '25px',       // Individual pill tabs
//                                         background: isHovered ? '#FFFFFF' : 'transparent', // Tab activation glow
//                                         border: isHovered ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         boxShadow: isHovered ? '0 4px 12px rgba(0,0,0,0.03)' : 'none',
//                                         transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//                                         display: 'inline-block'
//                                     }}
//                                 >
//                                     {/* Dot indicator matching the accent gold hue */}
//                                     <span style={{
//                                         color: '#D4AF37',
//                                         marginRight: '6px',
//                                         opacity: isHovered ? 1 : 0,
//                                         transition: 'opacity 0.2s ease'
//                                     }}>•</span>
//                                     {item.name}
//                                 </Link>
//                             );
//                         })}
//                     </nav>

//                     {/* Structural Fine Line Divider */}
//                     <div style={{ width: '1px', height: '20px', background: 'rgba(44, 48, 46, 0.15)' }} />

//                     {/* Dynamic Action Trigger Button */}
//                     <Link to="/ContactUs" style={{ textDecoration: 'none' }}>
//                         <button style={{
//                             background: '#2C302E',
//                             color: '#FFFFFF',
//                             border: 'none',
//                             padding: '10px 22px',
//                             borderRadius: '20px',
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             letterSpacing: '1px',
//                             textTransform: 'uppercase',
//                             cursor: 'pointer',
//                             boxShadow: '0 4px 12px rgba(44, 48, 46, 0.15)',
//                             transition: 'all 0.2s ease'
//                         }}
//                             onMouseEnter={(e) => {
//                                 e.target.style.background = '#D4AF37'; // Swaps to Champagne Gold on hover
//                                 e.target.style.transform = 'translateY(-1px)';
//                             }}
//                             onMouseLeave={(e) => {
//                                 e.target.style.background = '#2C302E';
//                                 e.target.style.transform = 'translateY(0)';
//                             }}
//                         >
//                             Inquire
//                         </button>
//                     </Link>
//                 </div>
//             </header>


//             {/* ==================== LOCAL BACKGROUND VIDEO ==================== */}
//             <video
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//                 style={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover',
//                     transform: 'translate(-50%, -50%)',
//                     zIndex: 1
//                 }}
//             >
//                 {/* 2. USE THE IMPORTED VARIABLE NAME HERE */}
//                 <source src={myBackgroundVideo} type="video/mp4" />
//                 Your browser does not support the video tag.
//             </video>

//             {/* Dark Readability Overlay */}
//             <div style={{
//                 position: 'absolute',
//                 top: 0,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 background: 'rgba(0, 0, 0, 0.5)',
//                 zIndex: 2
//             }} />

//             {/* ==================== HERO CONTENT ==================== */}
//             <div className="animate-fade-in" style={{
//                 position: 'relative',
//                 zIndex: 3,
//                 height: '100%',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 textAlign: 'center',
//                 padding: '0 20px',
//                 color: '#ffffff'
//             }}>
//                 <h1 style={{ fontSize: '3.8rem', fontWeight: '700', marginBottom: '20px', letterSpacing: '1px' }}>
//                     Elevate Your Living Space
//                 </h1>

//                 <p style={{ fontSize: '1.25rem', maxWidth: '600px', lineHeight: '1.6', marginBottom: '40px', color: '#e5e5e5' }}>
//                     Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design.
//                 </p>

//                 <Link to="/projects">
//                     <button style={{
//                         padding: '14px 40px',
//                         fontSize: '1rem',
//                         fontWeight: '600',
//                         color: '#000000',
//                         backgroundColor: '#ffffff',
//                         border: 'none',
//                         borderRadius: '30px',
//                         cursor: 'pointer',
//                         boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
//                         transition: 'transform 0.2s ease, background-color 0.2s'
//                     }}
//                         onMouseEnter={(e) => {
//                             e.target.style.transform = 'scale(1.05)';
//                             e.target.style.backgroundColor = '#f0f0f0';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.transform = 'scale(1)';
//                             e.target.style.backgroundColor = '#ffffff';
//                         }}
//                     >
//                         Explore Projects
//                     </button>
//                 </Link>
//             </div>
//         </div>
//     );
// };

// export default Landingscreen;


// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import myBackgroundVideo from '../Assets/landingvideo.mp4'; 
// import studioLogo from '../Assets/logo-removebg-preview.png';

// const Landingscreen = () => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//     const menuItems = [
//         { name: 'Home', path: '/' },
//         { name: 'Projects', path: '/projects' },
//         { name: 'About Us', path: '/about' },
//         { name: 'Contact', path: '/ContactUs' }
//     ];

//     // Premium Pastel Studio Design Tokens
//     const theme = {
//         background: '#F8F6F2',    
//         accent: '#D4AF37',        
//         textMain: '#2C302E',      
//         textMuted: '#4A504E',     
//         border: 'rgba(44, 48, 46, 0.12)' 
//     };

//     // Responsive Typography & Layout Keyframe Injector
//     const animationStyles = `
//     @keyframes fadeInUp {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-fade-in { animation: fadeInUp 1.2s ease-out forwards; }

//     /* Media Queries for Layout Responsiveness */
//     @media (max-width: 991px) {
//         .desktop-nav-group { display: none !important; }
//         .mobile-toggle-btn { display: flex !important; }
//         .hero-title { font-size: 2.5rem !important; }
//         .hero-desc { font-size: 1.1rem !important; max-width: 90% !important; }
//         .header-capsule { padding: 10px 20px !important; width: 95% !important; }
//     }
//   `;

//     return (
//         <div style={{
//             position: 'relative',
//             height: '100vh',
//             width: '100vw',
//             overflow: 'hidden',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             background: theme.background
//         }}>
//             <style>{animationStyles}</style>

//             {/* ==================== FIXED HEADER ==================== */}
//             <header 
//                 className="header-capsule"
//                 style={{
//                     position: 'fixed',
//                     top: '20px',                  
//                     left: '50%',
//                     transform: 'translateX(-50%)', 
//                     width: '90%',                 
//                     maxWidth: '1200px',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     padding: '12px 40px',         
//                     boxSizing: 'border-box',
//                     zIndex: 10,
//                     background: 'rgba(248, 246, 242, 0.85)',
//                     backdropFilter: 'blur(12px) saturate(110%)',
//                     WebkitBackdropFilter: 'blur(12px) saturate(110%)',
//                     borderRadius: '50px',         
//                     border: '1px solid rgba(44, 48, 46, 0.08)',
//                     boxShadow: '0 10px 30px rgba(44, 48, 46, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
//                     transition: 'all 0.3s ease'
//                 }}
//             >
//                 {/* LEFT LOGO AREA */}
//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     height: '42px',           
//                     transition: 'transform 0.3s ease'
//                 }}
//                     onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.03)'}
//                     onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                 >
//                     <img src={studioLogo} alt="ST Interior Studio Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
//                 </div>

//                 {/* DESKTOP NAVIGATION DECK */}
//                 <div className="desktop-nav-group" style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             return (
//                                 <Link
//                                     key={index}
//                                     to={item.path}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         color: '#2C302E', 
//                                         textDecoration: 'none',
//                                         fontSize: '0.9rem',
//                                         fontWeight: isHovered ? '600' : '500',
//                                         letterSpacing: '0.8px',
//                                         textTransform: 'uppercase', 
//                                         padding: '8px 18px',
//                                         borderRadius: '25px',       
//                                         background: isHovered ? '#FFFFFF' : 'transparent', 
//                                         border: isHovered ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         boxShadow: isHovered ? '0 4px 12px rgba(0,0,0,0.03)' : 'none',
//                                         transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//                                         display: 'inline-block'
//                                     }}
//                                 >
//                                     <span style={{ color: '#D4AF37', marginRight: '6px', opacity: isHovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>•</span>
//                                     {item.name}
//                                 </Link>
//                             );
//                         })}
//                     </nav>

//                     <div style={{ width: '1px', height: '20px', background: 'rgba(44, 48, 46, 0.15)' }} />

//                     <Link to="/ContactUs" style={{ textDecoration: 'none' }}>
//                         <button style={{
//                             background: '#2C302E', color: '#FFFFFF', border: 'none', padding: '10px 22px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', boxShadow: '0 4px 12px rgba(44, 48, 46, 0.15)', transition: 'all 0.2s ease'
//                         }}
//                         onMouseEnter={(e) => e.target.style.background = '#D4AF37'}
//                         onMouseLeave={(e) => e.target.style.background = '#2C302E'}
//                         >
//                             Inquire
//                         </button>
//                     </Link>
//                 </div>

//                 {/* MOBILE MENU HAMBURGER BUTTON */}
//                 <button 
//                     className="mobile-toggle-btn"
//                     onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                     style={{
//                         display: 'none',
//                         flexDirection: 'column',
//                         justifyContent: 'space-around',
//                         width: '24px',
//                         height: '20px',
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         padding: 0,
//                         zIndex: 110,
//                         outline: 'none'
//                     }}
//                 >
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(5px, -6px)' : 'none' }} />
//                 </button>
//             </header>

//             {/* ==================== MOBILE SLIDE-OUT MENU DRAWER ==================== */}
//             <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 right: 0,
//                 width: '100vw',
//                 height: '100vh',
//                 background: 'rgba(248, 246, 242, 0.98)',
//                 backdropFilter: 'blur(20px)',
//                 zIndex: 99,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 gap: '25px',
//                 transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
//                 transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
//             }}>
//                 {menuItems.map((item, index) => (
//                     <Link
//                         key={index}
//                         to={item.path}
//                         onClick={() => setMobileMenuOpen(false)}
//                         style={{
//                             color: theme.textMain,
//                             textDecoration: 'none',
//                             fontSize: '1.5rem',
//                             fontWeight: '300',
//                             letterSpacing: '2px',
//                             textTransform: 'uppercase',
//                             transition: 'color 0.3s'
//                         }}
//                         onMouseEnter={(e) => e.target.style.color = theme.accent}
//                         onMouseLeave={(e) => e.target.style.color = theme.textMain}
//                     >
//                         {item.name}
//                     </Link>
//                 ))}
//                 <Link to="/ContactUs" onClick={() => setMobileMenuOpen(false)} style={{ textDecoration: 'none', marginTop: '20px' }}>
//                     <button style={{ background: theme.textMain, color: '#FFF', border: 'none', padding: '14px 40px', borderRadius: '30px', fontSize: '1rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>
//                         Inquire
//                     </button>
//                 </Link>
//             </div>

//             {/* ==================== BACKGROUND VIDEO CONTAINER ==================== */}
//             <video
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//                 style={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover',
//                     transform: 'translate(-50%, -50%)',
//                     zIndex: 1,
//                     filter: 'brightness(95%) contrast(105%)'
//                 }}
//             >
//                 <source src={myBackgroundVideo} type="video/mp4" />
//                 Your browser does not support the video tag.
//             </video>

//             {/* Pastel Protection Protective Layer */}
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(248, 246, 242, 0.25)', zIndex: 2 }} />

//             {/* ==================== HERO LAYOUT BLOCK ==================== */}
//             <div className="animate-fade-in" style={{
//                 position: 'relative',
//                 zIndex: 3,
//                 height: '100%',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 textAlign: 'center',
//                 padding: '0 20px',
//                 color: theme.textMain
//             }}>
//                 <h1 className="hero-title" style={{ fontSize: '3.8rem', fontWeight: '300', marginBottom: '20px', letterSpacing: '1px', textShadow: '0 2px 10px rgba(255,255,255,0.6)' }}>
//                     Elevate Your Living Space
//                 </h1>

//                 <p className="hero-desc" style={{ fontSize: '1.25rem', maxWidth: '600px', lineHeight: '1.6', marginBottom: '40px', color: theme.textMuted, textShadow: '0 1px 8px rgba(255,255,255,0.7)' }}>
//                     Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design.
//                 </p>

//                 <Link to="/projects">
//                     <button style={{
//                         padding: '14px 40px', fontSize: '1rem', fontWeight: '600', color: '#FFFFFF', backgroundColor: theme.textMain, border: 'none', borderRadius: '30px', cursor: 'pointer', boxShadow: '0 4px 20px rgba(44, 48, 46, 0.25)', transition: 'transform 0.2s ease'
//                     }}
//                         onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
//                         onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
//                     >
//                         Explore Projects
//                     </button>
//                 </Link>
//             </div>
//         </div>
//     );
// };

// export default Landingscreen;





// import React, { useState } from 'react';
// import myBackgroundVideo from '../Assets/landingvideo.mp4';
// import studioLogo from '../Assets/logo-removebg-preview.png';

// // Receive activeNavId pointer props sent from Homescreen.js wrapper layout core
// const Landingscreen = ({ activeNavId }) => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);

//     // Map targets to line up with our container section id strings
//     const menuItems = [
//         { name: 'Home', targetId: 'home' },
//         { name: 'Projects', targetId: 'projects' },
//         { name: 'About Us', targetId: 'about' },
//         { name: 'Contact', targetId: 'contact' }
//     ];

//     const theme = {
//         background: '#F8F6F2',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#4A504E',
//         border: 'rgba(44, 48, 46, 0.12)'
//     };

//     // Smooth Scrolling Deck Controller
//     const scrollToSectionId = (targetId) => {
//         const structuralElement = document.getElementById(targetId);
//         if (structuralElement) {
//             structuralElement.scrollIntoView({
//                 behavior: 'smooth', // Native linear deceleration scroll physics
//                 block: 'start'      // Snaps section panel flush against top display line
//             });
//         }
//     };

//     return (
//         <div style={{ position: 'relative', height: '100vh', width: '100vw', overflow: 'hidden' }}>

//             {/* ==================== BALANCED FLOATING CAPSULE NAVIGATION HEADER ==================== */}
//             <header className="header-capsule" style={{
//                 position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)',
//                 width: '90%', maxWidth: '1200px', display: 'flex', justifyContent: 'space-between',
//                 alignItems: 'center', padding: '12px 40px', boxSizing: 'border-box', zIndex: 10,
//                 background: 'rgba(248, 246, 242, 0.85)', backdropFilter: 'blur(12px)',
//                 borderRadius: '50px', border: '1px solid rgba(44, 48, 46, 0.08)',
//                 boxShadow: '0 10px 30px rgba(44, 48, 46, 0.05)'
//             }}>
//                 <div style={{ display: 'flex', alignItems: 'center', height: '42px' }}>
//                     <img src={studioLogo} alt="ST Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
//                 </div>

//                 <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             // Check if current button loop corresponds to section currently intersecting viewport screen parameters
//                             const isActiveSection = activeNavId === item.targetId;

//                             return (
//                                 <button
//                                     key={index}
//                                     onClick={() => scrollToSectionId(item.targetId)}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         background: isHovered || isActiveSection ? '#FFFFFF' : 'transparent',
//                                         color: theme.textMain,
//                                         border: isHovered || isActiveSection ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         padding: '8px 18px', borderRadius: '25px', fontSize: '0.9rem',
//                                         fontWeight: isHovered || isActiveSection ? '600' : '500',
//                                         cursor: 'pointer', transition: 'all 0.3s ease', outline: 'none'
//                                     }}
//                                 >
//                                     {/* The Golden Dot stays cleanly visible whenever section is actively open on layout viewport */}
//                                     <span style={{
//                                         color: theme.accent, marginRight: '6px',
//                                         opacity: isHovered || isActiveSection ? 1 : 0,
//                                         transition: 'opacity 0.2s'
//                                     }}>•</span>
//                                     {item.name}
//                                 </button>
//                             );
//                         })}
//                     </nav>
//                 </div>
//             </header>

//             {/* BACKGROUND VIDEO */}
//             <video autoPlay loop muted playsInline style={{ position: 'absolute', top: '50%', left: '50%', width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(-50%, -50%)', zIndex: 1, filter: 'brightness(95%) contrast(105%)' }}>
//                 <source src={myBackgroundVideo} type="video/mp4" />
//             </video>
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(248, 246, 242, 0.25)', zIndex: 2 }} />

//             {/* HERO TYPOGRAPHY CARD TEXT CONTENT */}
//             <div className="animate-fade-in" style={{ position: 'relative', zIndex: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: theme.textMain }}>
//                 <h1 style={{ fontSize: '3.8rem', fontWeight: '400', marginBottom: '20px', textShadow: '0 2px 10px rgba(255,255,255,0.6)' }}>Elevate Your Living Space</h1>
//                 <p style={{ fontSize: '1.25rem', maxWidth: '600px', lineHeight: '1.6', marginBottom: '40px', color: theme.textMuted }}>Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design.</p>
//                 <button onClick={() => scrollToSectionId('projects')} style={{ padding: '14px 40px', fontSize: '1rem', fontWeight: '600', color: '#FFFFFF', backgroundColor: theme.textMain, border: 'none', borderRadius: '30px', cursor: 'pointer', boxShadow: '0 4px 20px rgba(44, 48, 46, 0.25)' }}>Explore Projects</button>
//             </div>
//         </div>
//     );
// };

// export default Landingscreen;


// import React, { useState } from 'react';
// import myBackgroundVideo from '../Assets/landingvideo.mp4'; 
// import studioLogo from '../Assets/logo-removebg-preview.png';

// const Landingscreen = ({ activeNavId }) => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//     const menuItems = [
//         { name: 'Home', targetId: 'home' },
//         { name: 'Projects', targetId: 'projects' },
//         { name: 'About Us', targetId: 'about' },
//         { name: 'Contact', targetId: 'contact' }
//     ];

//     const theme = {
//         background: '#F8F6F2',    
//         accent: '#D4AF37',        
//         textMain: '#2C302E',      
//         textMuted: '#4A504E',     
//         border: 'rgba(44, 48, 46, 0.12)' 
//     };

//     const scrollToSectionId = (targetId) => {
//         setMobileMenuOpen(false); // Instantly closes mobile drawer if open
//         const structuralElement = document.getElementById(targetId);
//         if (structuralElement) {
//             structuralElement.scrollIntoView({
//                 behavior: 'smooth', 
//                 block: 'start'      
//             });
//         }
//     };

//     // Global CSS Rule Injections for Fluid Mobile Media Scaling
//     const responsiveStyles = `
//     @keyframes fadeInUp {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-fade-in { animation: fadeInUp 1.2s ease-out forwards; }

//     /* ==================== GLOBAL MOBILE CONFIGURATIONS ==================== */
//     @media (max-width: 991px) {
//         .desktop-navigation-deck { display: none !important; }
//         .mobile-hamburger-btn { display: flex !important; }
//         .hero-main-title { font-size: 2.4rem !important; line-height: 1.2 !important; max-width: 90% !important; }
//         .hero-sub-paragraph { font-size: 1.05rem !important; max-width: 85% !important; margin-bottom: 30px !important; }
//         .header-capsule-bar { padding: 10px 20px !important; width: 95% !important; top: 15px !important; }
//     }
//   `;

//     return (
//         <div style={{ position: 'relative', height: '100vh', width: '100vw', overflow: 'hidden', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
//             <style>{responsiveStyles}</style>

//             {/* ==================== FLOATING CAPSULE NAVIGATION HEADER ==================== */}
//             <header className="header-capsule-bar" style={{
//                 position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)',
//                 width: '90%', maxWidth: '1200px', display: 'flex', justifyContent: 'space-between',
//                 alignItems: 'center', padding: '12px 40px', boxSizing: 'border-box', zIndex: 100,
//                 background: 'rgba(248, 246, 242, 0.85)', backdropFilter: 'blur(12px)',
//                 WebkitBackdropFilter: 'blur(12px)',
//                 borderRadius: '50px', border: '1px solid rgba(44, 48, 46, 0.08)',
//                 boxShadow: '0 10px 30px rgba(44, 48, 46, 0.05)',
//                 transition: 'all 0.3s ease'
//             }}>
//                 {/* STUDIO BRAND LOGO BLOCK */}
//                 <div style={{ display: 'flex', alignItems: 'center', height: '42px' }}>
//                     <img src={studioLogo} alt="ST Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
//                 </div>

//                 {/* DESKTOP VIEWPORTS DECK CONTROL */}
//                 <div className="desktop-navigation-deck" style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             const isActiveSection = activeNavId === item.targetId;

//                             return (
//                                 <button
//                                     key={index}
//                                     onClick={() => scrollToSectionId(item.targetId)}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         background: isHovered || isActiveSection ? '#FFFFFF' : 'transparent',
//                                         color: theme.textMain,
//                                         border: isHovered || isActiveSection ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         padding: '8px 18px', borderRadius: '25px', fontSize: '0.9rem',
//                                         fontWeight: isHovered || isActiveSection ? '600' : '500',
//                                         cursor: 'pointer', transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', outline: 'none',
//                                         letterSpacing: '0.5px'
//                                     }}
//                                 >
//                                     <span style={{ 
//                                         color: theme.accent, marginRight: '6px', 
//                                         opacity: isHovered || isActiveSection ? 1 : 0, 
//                                         transition: 'opacity 0.2s' 
//                                     }}>•</span>
//                                     {item.name}
//                                 </button>
//                             );
//                         })}
//                     </nav>

//                     <div style={{ width: '1px', height: '20px', background: 'rgba(44, 48, 46, 0.15)' }} />

//                     <button 
//                         onClick={() => scrollToSectionId('contact')} 
//                         style={{
//                             background: '#2C302E', color: '#FFFFFF', border: 'none', padding: '10px 22px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', boxShadow: '0 4px 12px rgba(44, 48, 46, 0.15)', transition: 'all 0.2s ease', outline: 'none'
//                         }}
//                         onMouseEnter={(e) => e.target.style.background = theme.accent}
//                         onMouseLeave={(e) => e.target.style.background = '#2C302E'}
//                     >
//                         Inquire
//                     </button>
//                 </div>

//                 {/* MOBILE VIEW INTERACTIVE HAMBURGER TRIGGER TOGGLE */}
//                 <button 
//                     className="mobile-hamburger-btn"
//                     onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                     style={{
//                         display: 'none', flexDirection: 'column', justifyContent: 'space-around',
//                         width: '22px', height: '18px', background: 'none', border: 'none',
//                         cursor: 'pointer', padding: 0, zIndex: 120, outline: 'none'
//                     }}
//                 >
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(4px, -5px)' : 'none' }} />
//                 </button>
//             </header>

//             {/* ==================== MOBILE SLIDE-OUT SINGLE-PAGE MENU DRAWER ==================== */}
//             <div style={{
//                 position: 'fixed', top: 0, right: 0, width: '100vw', height: '100vh',
//                 background: 'rgba(248, 246, 242, 0.98)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
//                 zIndex: 90, display: 'flex', flexDirection: 'column', justifyContent: 'center',
//                 alignItems: 'center', gap: '30px',
//                 transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
//                 transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
//             }}>
//                 {menuItems.map((item, index) => (
//                     <button
//                         key={index}
//                         onClick={() => scrollToSectionId(item.targetId)}
//                         style={{
//                             background: 'none', border: 'none', color: theme.textMain,
//                             fontSize: '1.4rem', fontWeight: '300', letterSpacing: '2px',
//                             textTransform: 'uppercase', cursor: 'pointer', outline: 'none'
//                         }}
//                     >
//                         {item.name}
//                     </button>
//                 ))}
//                 <button 
//                     onClick={() => scrollToSectionId('contact')}
//                     style={{ background: theme.textMain, color: '#FFF', border: 'none', padding: '14px 40px', borderRadius: '30px', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '15px', outline: 'none' }}
//                 >
//                     Inquire
//                 </button>
//             </div>

//             {/* ==================== LOCAL BACKGROUND CANVAS VIDEO STREAM ==================== */}
//             <video autoPlay loop muted playsInline style={{ position: 'absolute', top: '50%', left: '50%', width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(-50%, -50%)', zIndex: 1, filter: 'brightness(95%) contrast(105%)' }}>
//                 <source src={myBackgroundVideo} type="video/mp4" />
//             </video>

//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(248, 246, 242, 0.25)', zIndex: 2 }} />

//             {/* ==================== HERO LAYOUT BLOCK CONTENT ==================== */}
//             <div className="animate-fade-in" style={{ position: 'relative', zIndex: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '0 20px', color: theme.textMain }}>
//                 <h1 className="hero-main-title" style={{ fontSize: '3.8rem', fontWeight: '300', marginBottom: '20px', letterSpacing: '1px', textShadow: '0 2px 10px rgba(255,255,255,0.6)', maxWidth: '800px', lineHeight: '1.1' }}>
//                     Elevate Your Living Space
//                 </h1>
//                 <p className="hero-sub-paragraph" style={{ fontSize: '1.25rem', maxWidth: '600px', lineHeight: '1.6', marginBottom: '40px', color: theme.textMuted, textShadow: '0 1px 8px rgba(255,255,255,0.7)', fontWeight: '400' }}>
//                     Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design.
//                 </p>
//                 <button onClick={() => scrollToSectionId('projects')} style={{ padding: '14px 40px', fontSize: '1rem', fontWeight: '600', color: '#FFFFFF', backgroundColor: theme.textMain, border: 'none', borderRadius: '30px', cursor: 'pointer', boxShadow: '0 4px 20px rgba(44, 48, 46, 0.25)', transition: 'transform 0.2s ease', outline: 'none' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.03)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
//                     Explore Projects
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default Landingscreen;


// import React, { useState, useEffect } from 'react';
// import studioLogo from '../Assets/logo-removebg-preview.png';

// // Import your 5 images here (Replace with your actual paths)
// import img5 from '../Assets/Landingscreen Img/06981.jpg';
// import img1 from '../Assets/Landingscreen Img/07104.jpg';
// import img3 from '../Assets/Landingscreen Img/IMG_7512-HDR.jpg';
// import img4 from '../Assets/Landingscreen Img/IMG_7609-2.jpg';
// import img2 from '../Assets/Landingscreen Img/03775.jpg';



// const Landingscreen = ({ activeNavId }) => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [currentImageIndex, setCurrentImageIndex] = useState(0);

//     const menuItems = [
//         { name: 'Home', targetId: 'home' },
//         { name: 'About Us', targetId: 'about' },
//         { name: 'Projects', targetId: 'projects' },
//         { name: 'Contact', targetId: 'contact' }
//     ];

//     const images = [img1, img2, img3, img4, img5];

//     const theme = {
//         background: '#F8F6F2',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#4A504E',
//         border: 'rgba(44, 48, 46, 0.12)'
//     };

//     // Auto-change background image every 5 seconds
//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
//         }, 5000);

//         return () => clearInterval(interval);
//     }, [images.length]);

//     const scrollToSectionId = (targetId) => {
//         setMobileMenuOpen(false);
//         const structuralElement = document.getElementById(targetId);
//         if (structuralElement) {
//             structuralElement.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             });
//         }
//     };

//     const responsiveStyles = `
//     @keyframes fadeInUp {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-fade-in { animation: fadeInUp 1.2s ease-out forwards; }

//     /* ==================== GLOBAL MOBILE CONFIGURATIONS ==================== */
//     @media (max-width: 991px) {
//         .desktop-navigation-deck { display: none !important; }
//         .mobile-hamburger-btn { display: flex !important; }
//         .hero-main-title { font-size: 2.2rem !important; line-height: 1.2 !important; max-width: 90% !important; }
//         .hero-sub-paragraph { font-size: 1rem !important; max-width: 85% !important; margin-bottom: 30px !important; color: #EAEAEA !important; }
//         .header-capsule-bar { padding: 10px 20px !important; width: 95% !important; top: 15px !important; }
//     }
//   `;

//     return (
//         <div style={{ position: 'relative', height: '100vh', width: '100vw', overflow: 'hidden', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
//             <style>{responsiveStyles}</style>

//             {/* ==================== FLOATING CAPSULE NAVIGATION HEADER ==================== */}
//             <header className="header-capsule-bar" style={{
//                 position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)',
//                 width: '90%', maxWidth: '1200px', display: 'flex', justifyContent: 'space-between',
//                 alignItems: 'center', padding: '12px 40px', boxSizing: 'border-box', zIndex: 100,
//                 background: 'rgba(248, 246, 242, 0.85)', backdropFilter: 'blur(12px)',
//                 WebkitBackdropFilter: 'blur(12px)',
//                 borderRadius: '50px', border: '1px solid rgba(44, 48, 46, 0.08)',
//                 boxShadow: '0 10px 30px rgba(44, 48, 46, 0.05)',
//                 transition: 'all 0.3s ease'
//             }}>
//                 <div style={{ display: 'flex', alignItems: 'center', height: '42px' }}>
//                     <img src={studioLogo} alt="ST Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
//                 </div>

//                 <div className="desktop-navigation-deck" style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             const isActiveSection = activeNavId === item.targetId;

//                             return (
//                                 <button
//                                     key={index}
//                                     onClick={() => scrollToSectionId(item.targetId)}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         background: isHovered || isActiveSection ? '#FFFFFF' : 'transparent',
//                                         color: theme.textMain,
//                                         border: isHovered || isActiveSection ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         padding: '8px 18px', borderRadius: '25px', fontSize: '0.9rem',
//                                         fontWeight: isHovered || isActiveSection ? '600' : '500',
//                                         cursor: 'pointer', transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', outline: 'none',
//                                         letterSpacing: '0.5px'
//                                     }}
//                                 >
//                                     <span style={{
//                                         color: theme.accent, marginRight: '6px',
//                                         opacity: isHovered || isActiveSection ? 1 : 0,
//                                         transition: 'opacity 0.2s'
//                                     }}>•</span>
//                                     {item.name}
//                                 </button>
//                             );
//                         })}
//                     </nav>

//                     <div style={{ width: '1px', height: '20px', background: 'rgba(44, 48, 46, 0.15)' }} />

//                     <button
//                         onClick={() => scrollToSectionId('contact')}
//                         style={{
//                             background: '#2C302E', color: '#FFFFFF', border: 'none', padding: '10px 22px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', boxShadow: '0 4px 12px rgba(44, 48, 46, 0.15)', transition: 'all 0.2s ease', outline: 'none'
//                         }}
//                         onMouseEnter={(e) => e.target.style.background = theme.accent}
//                         onMouseLeave={(e) => e.target.style.background = '#2C302E'}
//                     >
//                         Inquire
//                     </button>
//                 </div>

//                 <button
//                     className="mobile-hamburger-btn"
//                     onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                     style={{
//                         display: 'none', flexDirection: 'column', justifyContent: 'space-around',
//                         width: '22px', height: '18px', background: 'none', border: 'none',
//                         cursor: 'pointer', padding: 0, zIndex: 120, outline: 'none'
//                     }}
//                 >
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(4px, -5px)' : 'none' }} />
//                 </button>
//             </header>

//             {/* ==================== MOBILE SLIDE-OUT MENU DRAWER ==================== */}
//             <div style={{
//                 position: 'fixed', top: 0, right: 0, width: '100vw', height: '100vh',
//                 background: 'rgba(248, 246, 242, 0.98)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
//                 zIndex: 90, display: 'flex', flexDirection: 'column', justifyContent: 'center',
//                 alignItems: 'center', gap: '30px',
//                 transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
//                 transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                 backgroundAttachment: "fixed",
//             }}>
//                 {menuItems.map((item, index) => (
//                     <button
//                         key={index}
//                         onClick={() => scrollToSectionId(item.targetId)}
//                         style={{
//                             background: 'none', border: 'none', color: theme.textMain,
//                             fontSize: '1.4rem', fontWeight: '300', letterSpacing: '2px',
//                             textTransform: 'uppercase', cursor: 'pointer', outline: 'none'
//                         }}
//                     >
//                         {item.name}
//                     </button>
//                 ))}
//                 <button
//                     onClick={() => scrollToSectionId('contact')}
//                     style={{ background: theme.textMain, color: '#FFF', border: 'none', padding: '14px 40px', borderRadius: '30px', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '15px', outline: 'none' }}
//                 >
//                     Inquire
//                 </button>
//             </div>

//             {/* ==================== RESPONSIVE IMAGE BACKGROUND SLIDER ==================== */}
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
//                 {images.map((imgSrc, index) => (
//                     <div
//                         key={index}
//                         style={{
//                             position: 'absolute',
//                             top: 0,
//                             left: 0,
//                             width: '100%',
//                             height: '100%',
//                             backgroundImage: `url(${imgSrc})`,
//                             backgroundSize: 'cover',
//                             backgroundPosition: 'center',
//                             opacity: currentImageIndex === index ? 1 : 0,
//                             transition: 'opacity 1s ease-in-out',
//                         }}
//                     />
//                 ))}
//             </div>

//             {/* Subtle radial gradient overlay to ensure readable center text without losing crisp image clarity */}
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'radial-gradient(circle, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 70%)', zIndex: 2 }} />

//             {/* ==================== HERO LAYOUT BLOCK CONTENT ==================== */}
//             {/* Conditional logic changed here: Only mounts and triggers animation on the 2nd image (index 1) */}
//             {currentImageIndex === 1 && (
//                 <div className="animate-fade-in" style={{ position: 'relative', zIndex: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '0 20px' }}>
//                     <h1 className="hero-main-title" style={{
//                         fontSize: '4.2rem',
//                         fontWeight: '300',
//                         marginBottom: '20px',
//                         letterSpacing: '1.5px',
//                         color: '#FFFFFF',
//                         textShadow: '0 4px 15px rgba(0, 0, 0, 0.35)',
//                         maxWidth: '900px',
//                         lineHeight: '1.15'
//                     }}>
//                         Design expression by shreya
//                     </h1>
//                     <p className="hero-sub-paragraph" style={{
//                         fontSize: '1.25rem',
//                         maxWidth: '650px',
//                         lineHeight: '1.6',
//                         marginBottom: '40px',
//                         color: '#F3F4F6',
//                         textShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
//                         fontWeight: '400',
//                         letterSpacing: '0.3px'
//                     }}>
//                         Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design.
//                     </p>
//                     <button
//                         onClick={() => scrollToSectionId('projects')}
//                         style={{
//                             padding: '14px 40px',
//                             fontSize: '1rem',
//                             fontWeight: '600',
//                             color: '#FFFFFF',
//                             backgroundColor: '#2C302E',
//                             border: 'none',
//                             borderRadius: '30px',
//                             cursor: 'pointer',
//                             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
//                             transition: 'all 0.2s ease',
//                             outline: 'none'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.transform = 'scale(1.03)';
//                             e.target.style.backgroundColor = theme.accent;
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.transform = 'scale(1)';
//                             e.target.style.backgroundColor = '#2C302E';
//                         }}
//                     >
//                         Explore Projects
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Landingscreen;


// import React, { useState } from 'react';
// import studioLogo from '../Assets/logo-removebg-preview.png';


// import img1 from '../Assets/Landingscreen Img/07104.jpg';
// import img2 from '../Assets/Landingscreen Img/slid2.jpg';
// import img3 from '../Assets/Landingscreen Img/slid3.jpg';
// import img4 from '../Assets/Landingscreen Img/slid4.jpg';
// import img5 from '../Assets/Landingscreen Img/slid5.jpg';
// import img6 from '../Assets/Landingscreen Img/slid6.jpg';
// import img7 from '../Assets/Landingscreen Img/slid7.jpg';




// const Landingscreen = ({ activeNavId }) => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [currentImageIndex, setCurrentImageIndex] = useState(0);

//     const menuItems = [
//         { name: 'Home', targetId: 'home' },
//         { name: 'know Us', targetId: 'about' },
//         { name: 'Projects', targetId: 'projects' },
//         { name: 'Contact', targetId: 'contact' }
//     ];

//     const images = [img1, img2, img3, img4, img5, img6, img7];

//     const theme = {
//         background: '#F8F6F2',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#4A504E',
//         border: 'rgba(44, 48, 46, 0.12)'
//     };

//     // Manual navigation functions
//     const handlePrevImage = () => {
//         setCurrentImageIndex((prevIndex) =>
//             prevIndex === 0 ? images.length - 1 : prevIndex - 1
//         );
//     };

//     const handleNextImage = () => {
//         setCurrentImageIndex((prevIndex) =>
//             (prevIndex + 1) % images.length
//         );
//     };

//     const scrollToSectionId = (targetId) => {
//         setMobileMenuOpen(false);
//         const structuralElement = document.getElementById(targetId);
//         if (structuralElement) {
//             structuralElement.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             });
//         }
//     };

//     const responsiveStyles = `
//     @keyframes fadeInUp {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-fade-in { animation: fadeInUp 1.2s ease-out forwards; }

//     /* ==================== GLOBAL MOBILE CONFIGURATIONS ==================== */
//     @media (max-width: 991px) {
//         .desktop-navigation-deck { display: none !important; }
//         .mobile-hamburger-btn { display: flex !important; }
//         .hero-main-title { font-size: 2.2rem !important; line-height: 1.2 !important; max-width: 90% !important; }
//         .hero-sub-paragraph { font-size: 1rem !important; max-width: 85% !important; margin-bottom: 30px !important; color: #EAEAEA !important; }
//         .header-capsule-bar { padding: 10px 20px !important; width: 95% !important; top: 15px !important; }
//         .nav-arrow-btn { width: 40px !important; height: 40px !important; font-size: 1.2rem !important; }
//         .header-logo-img {
//             max-height: 45px !important;
//             width: auto !important;
//     }
//   `;

//     return (
//         <div style={{ position: 'relative', height: '100vh', width: '100vw', overflow: 'hidden', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
//             <style>{responsiveStyles}</style>

//             {/* ==================== FLOATING CAPSULE NAVIGATION HEADER ==================== */}
//             {/* <header className="header-capsule-bar" style={{
//                 position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)',
//                 width: '90%', maxWidth: '1200px', display: 'flex', justifyContent: 'space-between',
//                 alignItems: 'center', padding: '12px 40px', boxSizing: 'border-box', zIndex: 100,
//                 background: 'rgba(248, 246, 242, 0.85)', backdropFilter: 'blur(12px)',
//                 WebkitBackdropFilter: 'blur(12px)',
//                 borderRadius: '50px', border: '1px solid rgba(44, 48, 46, 0.08)',
//                 boxShadow: '0 10px 30px rgba(44, 48, 46, 0.05)',
//                 transition: 'all 0.3s ease'
//             }}>
//                 <div style={{ display: 'flex', alignItems: 'center', height: '42px' }}>
//                     <img src={studioLogo} alt="ST Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
//                 </div>

//                 <div className="desktop-navigation-deck" style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             const isActiveSection = activeNavId === item.targetId;

//                             return (
//                                 <button
//                                     key={index}
//                                     onClick={() => scrollToSectionId(item.targetId)}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         background: isHovered || isActiveSection ? '#FFFFFF' : 'transparent',
//                                         color: theme.textMain,
//                                         border: isHovered || isActiveSection ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         padding: '8px 18px', borderRadius: '25px', fontSize: '0.9rem',
//                                         fontWeight: isHovered || isActiveSection ? '600' : '500',
//                                         cursor: 'pointer', transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', outline: 'none',
//                                         letterSpacing: '0.5px'
//                                     }}
//                                 >
//                                     <span style={{
//                                         color: theme.accent, marginRight: '6px',
//                                         opacity: isHovered || isActiveSection ? 1 : 0,
//                                         transition: 'opacity 0.2s'
//                                     }}>•</span>
//                                     {item.name}
//                                 </button>
//                             );
//                         })}
//                     </nav>

//                     <div style={{ width: '1px', height: '20px', background: 'rgba(44, 48, 46, 0.15)' }} />

//                     <button
//                         onClick={() => scrollToSectionId('contact')}
//                         style={{
//                             background: '#2C302E', color: '#FFFFFF', border: 'none', padding: '10px 22px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', boxShadow: '0 4px 12px rgba(44, 48, 46, 0.15)', transition: 'all 0.2s ease', outline: 'none'
//                         }}
//                         onMouseEnter={(e) => e.target.style.background = theme.accent}
//                         onMouseLeave={(e) => e.target.style.background = '#2C302E'}
//                     >
//                         Inquire
//                     </button>
//                 </div>

//                 <button
//                     className="mobile-hamburger-btn"
//                     onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                     style={{
//                         display: 'none', flexDirection: 'column', justifyContent: 'space-around',
//                         width: '22px', height: '18px', background: 'none', border: 'none',
//                         cursor: 'pointer', padding: 0, zIndex: 120, outline: 'none'
//                     }}
//                 >
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(4px, -5px)' : 'none' }} />
//                 </button>
//             </header> */}

//             {/* ==================== FULL-WIDTH EDGE-TO-EDGE HEADER ==================== */}
//             {/* <header className="header-full-bar" style={{
//                 position: 'fixed', top: 0, left: 0,
//                 width: '100vw', display: 'flex', justifyContent: 'space-between',
//                 alignItems: 'center', padding: '16px 60px', boxSizing: 'border-box', zIndex: 100,
//                 background: 'rgba(248, 246, 242, 0.88)', backdropFilter: 'blur(16px)',
//                 WebkitBackdropFilter: 'blur(16px)',
//                 borderBottom: '1px solid rgba(44, 48, 46, 0.08)',
//                 boxShadow: '0 4px 30px rgba(44, 48, 46, 0.03)',
//                 transition: 'all 0.3s ease'
//             }}>

//                 <div className="logo-container" style={{ display: 'flex', alignItems: 'center', height: '72px', transition: 'all 0.3s' }}>
//                     <img src={studioLogo} alt="ST Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
//                 </div>

//                 <div className="desktop-navigation-deck" style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
//                     <nav style={{ display: 'flex', gap: '8px' }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             const isActiveSection = activeNavId === item.targetId;

//                             return (
//                                 <button
//                                     key={index}
//                                     onClick={() => scrollToSectionId(item.targetId)}
//                                     onMouseEnter={() => setHoveredIndex(index)}
//                                     onMouseLeave={() => setHoveredIndex(null)}
//                                     style={{
//                                         background: isHovered || isActiveSection ? '#FFFFFF' : 'transparent',
//                                         color: theme.textMain,
//                                         border: isHovered || isActiveSection ? '1px solid rgba(44, 48, 46, 0.06)' : '1px solid transparent',
//                                         padding: '8px 18px', borderRadius: '25px', fontSize: '0.9rem',
//                                         fontWeight: isHovered || isActiveSection ? '600' : '500',
//                                         cursor: 'pointer', transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', outline: 'none',
//                                         letterSpacing: '0.5px'
//                                     }}
//                                 >
//                                     <span style={{
//                                         color: theme.accent, marginRight: '6px',
//                                         opacity: isHovered || isActiveSection ? 1 : 0,
//                                         transition: 'opacity 0.2s'
//                                     }}>•</span>
//                                     {item.name}
//                                 </button>
//                             );
//                         })}
//                     </nav>

//                     <div style={{ width: '1px', height: '20px', background: 'rgba(44, 48, 46, 0.15)' }} />

//                     <button
//                         onClick={() => scrollToSectionId('contact')}
//                         style={{
//                             background: '#2C302E', color: '#FFFFFF', border: 'none', padding: '10px 22px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', boxShadow: '0 4px 12px rgba(44, 48, 46, 0.15)', transition: 'all 0.2s ease', outline: 'none'
//                         }}
//                         onMouseEnter={(e) => e.target.style.background = theme.accent}
//                         onMouseLeave={(e) => e.target.style.background = '#2C302E'}
//                     >
//                         Inquire
//                     </button>
//                 </div>

//                 <button
//                     className="mobile-hamburger-btn"
//                     onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                     style={{
//                         display: 'none', flexDirection: 'column', justifyContent: 'space-around',
//                         width: '22px', height: '18px', background: 'none', border: 'none',
//                         cursor: 'pointer', padding: 0, zIndex: 120, outline: 'none'
//                     }}
//                 >
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
//                     <div style={{ width: '100%', height: '2px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(4px, -5px)' : 'none' }} />
//                 </button>
//             </header> */}

//             {/* ==================== TWO-ROW STUDIO HEADER ==================== */}
//             <header style={{
//                 position: 'fixed', top: 0, left: 0, width: '100vw', zIndex: 100,
//                 background: '#FFFFFF', borderBottom: `1px solid ${theme.border}`,
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
//             }}>
//                 {/* Row 1: Left-Aligned Large Logo Box */}
//                 <div className="header-top-row" style={{
//                     display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//                     padding: '20px 60px', height: '90px', boxSizing: 'border-box'
//                 }}>
//                     <img src={studioLogo} alt="Studio Logo" style={{ height: '100%', width: 'auto', objectFit: 'contain', }} />

//                     <div className="logo-container" style={{ display: 'flex', alignItems: 'center', height: '70px', flexDirection: "row", justifyContent: "center" }}>


//                         {/* <h1 className="hero-main-title" style={{
//                             fontSize: '1rem',
//                             fontWeight: '100',
//                             // marginBottom: '20px',
//                             letterSpacing: '1.5px',
//                             color: '#4A504E',
//                             // textShadow: '0 4px 15px rgba(0, 0, 0, 0.35)',
//                             maxWidth: '900px',
//                             lineHeight: '1.15',
//                             fontFamily: 'Georgia, serif',
//                         }}>
//                             Design Expression By Shreya
//                         </h1> */}
//                     </div>

//                     {/* Mobile Hamburger (Only visible on smaller viewports) */}
//                     <button
//                         className="mobile-hamburger-btn"
//                         onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                         style={{
//                             display: 'none', flexDirection: 'column', justifyContent: 'space-around',
//                             width: '24px', height: '18px', background: 'none', border: 'none',
//                             cursor: 'pointer', padding: 0, outline: 'none'
//                         }}
//                     >
//                         <div style={{ width: '100%', height: '1.5px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }} />
//                         <div style={{ width: '100%', height: '1.5px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
//                         <div style={{ width: '100%', height: '1.5px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(4px, -5px)' : 'none' }} />
//                     </button>
//                 </div>


//                 {/* Row 2: Spaced-out, Justified Navigation Links */}
//                 <div className="desktop-navigation-deck" style={{
//                     display: 'flex', justifyContent: 'center', borderTop: `1px solid ${theme.border}`,
//                     padding: '16px 60px', background: '#FFFFFF'
//                 }}>


//                     <nav style={{
//                         display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '1000px',
//                         gap: '20px'
//                     }}>
//                         {menuItems.map((item, index) => {
//                             const isHovered = hoveredIndex === index;
//                             const isActiveSection = activeNavId === item.targetId;

//                             return (
//                                 <>
//                                     <button
//                                         key={index}
//                                         onClick={() => scrollToSectionId(item.targetId)}
//                                         onMouseEnter={() => setHoveredIndex(index)}
//                                         onMouseLeave={() => setHoveredIndex(null)}
//                                         style={{
//                                             background: 'transparent',
//                                             color: isHovered || isActiveSection ? theme.accent : theme.textMuted,
//                                             border: 'none',
//                                             padding: '4px 10px',
//                                             fontSize: '0.9rem',
//                                             fontFamily: 'Georgia, serif',
//                                             textTransform: 'uppercase',
//                                             fontWeight: '400',
//                                             letterSpacing: '3px',
//                                             cursor: 'pointer',
//                                             transition: 'color 0.3s ease',
//                                             outline: 'none'
//                                         }}
//                                     >
//                                         {item.name}
//                                     </button>
//                                 </>
//                             );
//                         })}
//                     </nav>

//                 </div>
//             </header>

//             {/* ==================== MOBILE SLIDE-OUT MENU DRAWER ==================== */}
//             <div style={{
//                 position: 'fixed', top: 0, right: 0, width: '100vw', height: '100vh',
//                 background: 'rgba(248, 246, 242, 0.98)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
//                 zIndex: 90, display: 'flex', flexDirection: 'column', justifyContent: 'center',
//                 alignItems: 'center', gap: '30px',
//                 transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
//                 transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                 backgroundAttachment: "fixed",
//             }}>
//                 {menuItems.map((item, index) => (
//                     <button
//                         key={index}
//                         onClick={() => scrollToSectionId(item.targetId)}
//                         style={{
//                             background: 'none', border: 'none', color: theme.textMain,
//                             fontSize: '1.4rem', fontWeight: '300', letterSpacing: '2px',
//                             textTransform: 'uppercase', cursor: 'pointer', outline: 'none'
//                         }}
//                     >
//                         {item.name}
//                     </button>
//                 ))}
//                 <button
//                     onClick={() => scrollToSectionId('contact')}
//                     style={{ background: theme.textMain, color: '#FFF', border: 'none', padding: '14px 40px', borderRadius: '30px', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '15px', outline: 'none' }}
//                 >
//                     Inquire
//                 </button>
//             </div>

//             {/* ==================== RESPONSIVE IMAGE BACKGROUND SLIDER ==================== */}
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
//                 {images.map((imgSrc, index) => (
//                     <div
//                         key={index}
//                         style={{
//                             position: 'absolute',
//                             top: 0,
//                             left: 0,
//                             width: '100%',
//                             height: '100%',
//                             backgroundImage: `url(${imgSrc})`,
//                             backgroundSize: 'cover',
//                             backgroundPosition: 'center',
//                             opacity: currentImageIndex === index ? 1 : 0,
//                             transition: 'opacity 1s ease-in-out',
//                         }}
//                     />
//                 ))}
//             </div>

//             {/* Subtle radial gradient overlay to ensure readable center text without losing crisp image clarity */}
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'radial-gradient(circle, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 70%)', zIndex: 2 }} />

//             {/* ==================== MANUAL ARROW BUTTONS (SMOKEY WHITE + GOLD ARROWS) ==================== */}
//             <button
//                 className="nav-arrow-btn"
//                 onClick={handlePrevImage}
//                 style={{
//                     position: 'absolute', left: '30px', top: '50%', transform: 'translateY(-50%)',
//                     zIndex: 10, width: '54px', height: '54px', borderRadius: '50%',
//                     background: 'rgba(245, 245, 245, 0.2)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
//                     border: '1px solid rgba(255, 255, 255, 0.15)', color: '#D4AF37',
//                     fontSize: '1.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center',
//                     justifyContent: 'center', transition: 'all 0.3s ease', outline: 'none',
//                     boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
//                 }}
//                 onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.4)'; }}
//                 onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.2)'; }}
//             >
//                 &#8249;
//             </button>

//             <button
//                 className="nav-arrow-btn"
//                 onClick={handleNextImage}
//                 style={{
//                     position: 'absolute', right: '30px', top: '50%', transform: 'translateY(-50%)',
//                     zIndex: 10, width: '54px', height: '54px', borderRadius: '50%',
//                     background: 'rgba(245, 245, 245, 0.2)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
//                     border: '1px solid rgba(255, 255, 255, 0.15)', color: '#D4AF37',
//                     fontSize: '1.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center',
//                     justifyContent: 'center', transition: 'all 0.3s ease', outline: 'none',
//                     boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
//                 }}
//                 onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.4)'; }}
//                 onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.2)'; }}
//             >
//                 &#8250;
//             </button>

//             {/* ==================== BOTTOM PAGINATION DOTS ==================== */}
//             <div style={{
//                 position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)',
//                 zIndex: 10, display: 'flex', gap: '12px', alignItems: 'center'
//             }}>
//                 {images.map((_, index) => (
//                     <button
//                         key={index}
//                         onClick={() => setCurrentImageIndex(index)}
//                         style={{
//                             width: currentImageIndex === index ? '10px' : '8px',
//                             height: currentImageIndex === index ? '10px' : '8px',
//                             borderRadius: '50%',
//                             border: 'none',
//                             background: currentImageIndex === index ? '#D4AF37' : 'rgba(255, 255, 255, 0.4)',
//                             cursor: 'pointer',
//                             transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//                             outline: 'none',
//                             padding: 0
//                         }}
//                     />
//                 ))}
//             </div>

//             {/* ==================== HERO LAYOUT BLOCK CONTENT ==================== */}
//             {currentImageIndex === 0 && (
//                 <div className="animate-fade-in" style={{ position: 'relative', zIndex: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'end', alignItems: 'center', textAlign: 'center', padding: '0 20px' }}>

//                     {/* <p className="hero-sub-paragraph" style={{
//                         fontSize: '1.25rem',
//                         maxWidth: '650px',
//                         lineHeight: '1.6',
//                         marginBottom: '40px',
//                         color: '#F3F4F6',
//                         textShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
//                         fontWeight: '400',
//                         letterSpacing: '0.3px'
//                     }}>
//                         Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design.
//                     </p> */}
//                     <button
//                         onClick={() => scrollToSectionId('projects')}
//                         style={{
//                             padding: '10px 30px',
//                             fontSize: '1rem',
//                             fontWeight: '600',
//                             color: theme.textMain,
//                             backgroundColor: '#FFFFFF',
//                             fontFamily: 'Georgia, serif',
//                             border: 'none',
//                             borderRadius: '30px',
//                             cursor: 'pointer',
//                             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
//                             transition: 'all 0.2s ease',
//                             outline: 'none',
//                             marginBottom: "5%"
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.transform = 'scale(1.03)';
//                             e.target.style.backgroundColor = theme.accent;
//                             e.target.style.color = '#FFFFFF';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.transform = 'scale(1)';
//                             e.target.style.backgroundColor = '#FFFFFF';
//                             e.target.style.color = theme.textMain;
//                         }}
//                     >
//                         Explore Projects
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Landingscreen;

import React, { useState } from 'react';
import studioLogo from '../Assets/logo-removebg-preview.png';

import img1 from '../Assets/Landingscreen Img/07104.jpg';
import img2 from '../Assets/Landingscreen Img/slid2.jpg';
import img3 from '../Assets/Landingscreen Img/slid3.jpg';
import img4 from '../Assets/Landingscreen Img/slid4.jpg';
import img5 from '../Assets/Landingscreen Img/slid5.jpg';
import img6 from '../Assets/Landingscreen Img/slid6.jpg';
// import img7 from '../Assets/Landingscreen Img/slid7.jpg';

const Landingscreen = ({ activeNavId }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const menuItems = [
        { name: 'Home', targetId: 'home' },
        { name: 'know Us', targetId: 'about' },
        { name: 'Projects', targetId: 'projects' },
        { name: 'Contact', targetId: 'contact' }
    ];

    const images = [img1, img2, img3, img4, img5, img6,];

    const theme = {
        background: '#F8F6F2',
        accent: '#D4AF37',
        textMain: '#2C302E',
        textMuted: '#4A504E',
        border: 'rgba(44, 48, 46, 0.12)'
    };

    // Manual navigation functions
    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            (prevIndex + 1) % images.length
        );
    };

    const scrollToSectionId = (targetId) => {
        setMobileMenuOpen(false);
        const structuralElement = document.getElementById(targetId);
        if (structuralElement) {
            structuralElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    const responsiveStyles = `
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(30px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-fade-in { animation: fadeInUp 1.2s ease-out forwards; }

    /* ==================== RESPONSIVE HEADER & MOBILE CONFIGURATIONS ==================== */
    @media (max-width: 991px) {
        .desktop-navigation-deck { display: none !important; }
        .mobile-hamburger-btn { display: flex !important; }
        
        .header-single-row {
            padding: 10px 20px !important;
            height: 65px !important;
        }
        
        .header-logo-img {
            max-height: 40px !important;
            width: auto !important;
        }

        .hero-main-title { font-size: 2.2rem !important; line-height: 1.2 !important; max-width: 90% !important; }
        .hero-sub-paragraph { font-size: 1rem !important; max-width: 85% !important; margin-bottom: 30px !important; color: #EAEAEA !important; }
        
        .nav-arrow-btn { 
            width: 40px !important; 
            height: 40px !important; 
            font-size: 1.2rem !important; 
        }
        .nav-arrow-left { left: 10px !important; }
        .nav-arrow-right { right: 10px !important; }
    }
  `;

    return (
        <div style={{
            position: 'relative',
            minHeight: '100vh',
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden',
            overflowY: 'hidden',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
            <style>{responsiveStyles}</style>

            {/* ==================== SINGLE HEADER ROW (LOGO + NAV ALL IN ONE) ==================== */}
            <header style={{
                position: 'fixed', top: 0, left: 0, width: "auto", zIndex: 100,
                background: '#FFFFFF', borderBottom: `1px solid ${theme.border}`,
                boxShadow: '0 2px 10px rgba(0,0,0,0.03)', left: 0,
                right: 0,
            }}>
                <div className="header-single-row" style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '12px 40px', height: '75px', boxSizing: 'border-box', width: '100%'
                }}>
                    {/* Left: Studio Logo */}
                    <div style={{ display: 'flex', alignItems: 'center', height: '100%', minWidth: '150px' }}>
                        <img
                            src={studioLogo}
                            alt="Studio Logo"
                            className="header-logo-img"
                            style={{
                                maxHeight: '50px',
                                maxWidth: '100%',
                                width: 'auto',
                                objectFit: 'contain',
                                display: 'block'
                            }}
                        />
                    </div>

                    {/* Desktop Navigation Deck (Spaced out in same row) */}
                    <div className="desktop-navigation-deck" style={{ flex: 1, display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginLeft: '40px' }}>
                        <nav style={{ display: 'flex', justifyContent: 'space-around', width: '100%', maxWidth: '900px' }}>
                            {menuItems.map((item, index) => {
                                const isHovered = hoveredIndex === index;
                                const isActiveSection = activeNavId === item.targetId;

                                return (
                                    <button
                                        key={index}
                                        onClick={() => scrollToSectionId(item.targetId)}
                                        onMouseEnter={() => setHoveredIndex(index)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                        style={{
                                            background: 'transparent',
                                            color: isHovered || isActiveSection ? theme.accent : theme.textMuted,
                                            border: 'none',
                                            padding: '8px 16px',
                                            fontSize: '0.95rem',
                                            fontFamily: 'Georgia, serif',
                                            textTransform: 'uppercase',
                                            fontWeight: '400',
                                            letterSpacing: '2.5px',
                                            cursor: 'pointer',
                                            transition: 'color 0.3s ease',
                                            outline: 'none'
                                        }}
                                    >
                                        {item.name}
                                    </button>
                                );
                            })}
                        </nav>
                    </div>

                    {/* Mobile Hamburger Button */}
                    <button
                        className="mobile-hamburger-btn"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        aria-label="Toggle Navigation Menu"
                        style={{
                            display: 'none', flexDirection: 'column', justifyContent: 'space-around',
                            width: '24px', height: '18px', background: 'none', border: 'none',
                            cursor: 'pointer', padding: 0, outline: 'none'
                        }}
                    >
                        <div style={{ width: '100%', height: '1.5px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none' }} />
                        <div style={{ width: '100%', height: '1.5px', background: theme.textMain, transition: '0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
                        <div style={{ width: '100%', height: '1.5px', background: theme.textMain, transition: '0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(4px, -5px)' : 'none' }} />
                    </button>
                </div>
            </header>

            {/* ==================== MOBILE SLIDE-OUT MENU DRAWER ==================== */}
            <div style={{
                position: 'fixed', top: 0, right: 0, width: '100%', height: '100vh',
                background: 'rgba(248, 246, 242, 0.98)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
                zIndex: 90, display: 'flex', flexDirection: 'column', justifyContent: 'center',
                alignItems: 'center', gap: '30px',
                transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
                transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
            }}>
                {menuItems.map((item, index) => (
                    <button
                        key={index}
                        onClick={() => scrollToSectionId(item.targetId)}
                        style={{
                            background: 'none', border: 'none', color: theme.textMain,
                            fontSize: '1.4rem', fontWeight: '300', letterSpacing: '2px',
                            textTransform: 'uppercase', cursor: 'pointer', outline: 'none'
                        }}
                    >
                        {item.name}
                    </button>
                ))}
                <button
                    onClick={() => scrollToSectionId('contact')}
                    style={{ background: theme.textMain, color: '#FFF', border: 'none', padding: '14px 40px', borderRadius: '30px', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '15px', outline: 'none' }}
                >
                    Inquire
                </button>
            </div>

            {/* ==================== RESPONSIVE IMAGE BACKGROUND SLIDER ==================== */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
                {images.map((imgSrc, index) => (
                    <div
                        key={index}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundImage: `url(${imgSrc})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            opacity: currentImageIndex === index ? 1 : 0,
                            transition: 'opacity 1s ease-in-out',
                        }}
                    />
                ))}
            </div>

            {/* Subtle radial gradient overlay */}
            {/* <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'radial-gradient(circle, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 70%)', zIndex: 2 }} /> */}

            {/* ==================== MANUAL ARROW BUTTONS ==================== */}
            <button
                className="nav-arrow-btn nav-arrow-left"
                onClick={handlePrevImage}
                aria-label="Previous Image"
                style={{
                    position: 'absolute', left: '30px', top: '50%', transform: 'translateY(-50%)',
                    zIndex: 10, width: '54px', height: '54px', borderRadius: '50%',
                    background: 'rgba(245, 245, 245, 0.2)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.15)', color: '#D4AF37',
                    fontSize: '1.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', transition: 'all 0.3s ease', outline: 'none',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.4)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.2)'; }}
            >
                &#8249;
            </button>

            <button
                className="nav-arrow-btn nav-arrow-right"
                onClick={handleNextImage}
                aria-label="Next Image"
                style={{
                    position: 'absolute', right: '30px', top: '50%', transform: 'translateY(-50%)',
                    zIndex: 10, width: '54px', height: '54px', borderRadius: '50%',
                    background: 'rgba(245, 245, 245, 0.2)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.15)', color: '#D4AF37',
                    fontSize: '1.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', transition: 'all 0.3s ease', outline: 'none',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.4)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(245, 245, 245, 0.2)'; }}
            >
                &#8250;
            </button>

            {/* ==================== BOTTOM PAGINATION DOTS ==================== */}
            <div style={{
                position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)',
                zIndex: 10, display: 'flex', gap: '12px', alignItems: 'center'
            }}>
                {images.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentImageIndex(index)}
                        aria-label={`Go to image ${index + 1}`}
                        style={{
                            width: currentImageIndex === index ? '10px' : '8px',
                            height: currentImageIndex === index ? '10px' : '8px',
                            borderRadius: '50%',
                            border: 'none',
                            background: currentImageIndex === index ? '#D4AF37' : 'rgba(255, 255, 255, 0.4)',
                            cursor: 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                            outline: 'none',
                            padding: 0
                        }}
                    />
                ))}
            </div>

            {/* ==================== HERO LAYOUT BLOCK CONTENT ==================== */}
            {currentImageIndex === 0 && (
                <div className="animate-fade-in" style={{ position: 'relative', zIndex: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'end', alignItems: 'center', textAlign: 'center', padding: '0 20px' }}>
                    <button
                        onClick={() => scrollToSectionId('projects')}
                        style={{
                            padding: '10px 30px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: theme.textMain,
                            backgroundColor: '#FFFFFF',
                            fontFamily: 'Georgia, serif',
                            border: 'none',
                            borderRadius: '30px',
                            cursor: 'pointer',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
                            transition: 'all 0.2s ease',
                            outline: 'none',
                            marginBottom: "5%"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'scale(1.03)';
                            e.target.style.backgroundColor = theme.accent;
                            e.target.style.color = '#FFFFFF';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'scale(1)';
                            e.target.style.backgroundColor = '#FFFFFF';
                            e.target.style.color = theme.textMain;
                        }}
                    >
                        Explore Projects
                    </button>
                </div>
            )}
        </div>
    );
};

export default Landingscreen;